var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1738983138614,
    className: "icon",
    viewBox: "0 0 1117 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8684,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 327.24609375,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M372.425646 674.988412m23.267439 0l325.744149 0q23.267439 0 23.267439 23.267439l0 46.534878q0 23.267439-23.267439 23.26744l-325.744149 0q-23.267439 0-23.267439-23.26744l0-46.534878q0-23.267439 23.267439-23.267439Z",
    fill: "#55B97F",
    "p-id": 8685
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M742.19179 316.134697l-208.964872 200.495523a47.163099 47.163099 0 0 1-63.682981 6.514883 42.719018 42.719018 0 0 1 6.770825-61.100295l208.964871-200.495524a47.163099 47.163099 0 0 1 63.682982-6.491615 42.672484 42.672484 0 0 1-6.770825 61.077028z",
    fill: "#5AC389",
    "p-id": 8686
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M450.860183 386.960782l70.570143 70.477073a45.953192 45.953192 0 0 1 5.700523 64.264667 46.06953 46.06953 0 0 1-64.334469-5.72379l-70.546876-70.477073a45.929925 45.929925 0 0 1-5.72379-64.2414 46.06953 46.06953 0 0 1 64.334469 5.700523z",
    fill: "#5AC389",
    "p-id": 8687
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.025737 688.227585l-200.751466-180.927608a23.267439 23.267439 0 0 0-37.739786 18.334742v335.446672a23.267439 23.267439 0 0 1-23.26744 23.267439H283.869772a23.267439 23.267439 0 0 1-23.267439-23.267439v-143.373961a23.267439 23.267439 0 0 0-8.911429-18.311475l-93.069757-73.152828a23.267439 23.267439 0 0 0-37.763054 18.334742v262.922063a116.779277 116.779277 0 0 0 116.476801 116.337196h655.37396a116.779277 116.779277 0 0 0 116.476801-116.337196v-177.693433a23.267439 23.267439 0 0 1 23.267439-23.26744h61.007226c22.290207 0.069802 31.969461-4.63022 14.565417-18.311474z",
    fill: "#55B97F",
    "p-id": 8688
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260.602333 496.783095v-340.565508a16.287207 16.287207 0 0 1 16.287207-16.287208h574.868621a17.497114 17.497114 0 0 1 17.659986 16.287208v137.580368a16.287207 16.287207 0 0 0 6.258942 12.890161l106.913883 83.762782a16.287207 16.287207 0 0 0 26.52488-12.890162v-284.351374a93.232629 93.232629 0 0 0-93.069756-93.069757h-701.978642a93.232629 93.232629 0 0 0-93.069757 93.069757v192.07271a16.287207 16.287207 0 0 1-16.403544 16.287208h-87.95092a16.287207 16.287207 0 0 0-10.121336 29.270438l227.648625 178.624131a16.403545 16.403545 0 0 0 26.431811-12.680754z",
    fill: "#5AC389",
    "p-id": 8689
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.891dc55c480a28d8ac4d29f313fc490c.svg";
export { ForwardRef as ReactComponent };